'use client';

import React from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    console.error('[meet] client-side exception:', error);
    // Recover once from a transient crash; guard against reload loops.
    try {
      const KEY = 'lk-auto-reloaded-at';
      const now = Date.now();
      const last = Number(window.sessionStorage.getItem(KEY) || '0');
      if (now - last > 20000) {
        window.sessionStorage.setItem(KEY, String(now));
        window.location.reload();
      }
    } catch (_e) {
      // sessionStorage may be unavailable (in-app browsers) — ignore.
    }
  }, [error]);

  return (
    <html lang="ru">
      <body
        style={{
          margin: 0,
          height: '100vh',
          display: 'grid',
          placeItems: 'center',
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          background: '#111',
          color: '#eee',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: 420, padding: 24 }}>
          <h2 style={{ marginBottom: 8 }}>Переподключение…</h2>
          <p style={{ opacity: 0.8, marginBottom: 20 }}>
            Соединение с конференцией прервалось. Если страница не обновилась
            автоматически, нажмите кнопку ниже.
          </p>
          <button
            onClick={() => {
              try {
                window.sessionStorage.removeItem('lk-auto-reloaded-at');
              } catch (_e) {}
              reset();
              window.location.reload();
            }}
            style={{
              padding: '12px 24px',
              fontSize: 16,
              borderRadius: 8,
              border: 'none',
              background: '#1f8cff',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            Переподключиться
          </button>
        </div>
      </body>
    </html>
  );
}
